import { Model as s } from "../../../model.js";
class t extends s {
  constructor(o) {
    super(), this.amount = o.amount, this.feeType = o.feeType, this.flat = o.flat, this.name = o.name, this.rate = o.rate, this.voided = o.voided;
  }
}
export {
  t as TicketFeeModel
};
//# sourceMappingURL=ticketFee.model.js.map
